import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type AlertProps = {
  isVisible?: boolean;
  message?: string;
  type?: "error" | "success" | null;
};

type InitialValuesProps = {
  loader?: boolean;
  isBlankLoader?: boolean;
  alert?: AlertProps;
  cookieConsent?: boolean;
};

const initialState: InitialValuesProps = {
  loader: false,
  isBlankLoader: false,
  cookieConsent: false,
  alert: {
    isVisible: false,
    message: "",
    type: null,
  },
};

const LoaderSnackbarWrapperSlice = createSlice({
  name: "LoaderSnackbarWrapper",
  initialState: initialState,
  reducers: {
    setGlobalAppearances: (
      state,
      action: PayloadAction<InitialValuesProps>
    ) => {
      return { ...state, ...action.payload };
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
});

export const LoaderSnackbarWrapperReducer = LoaderSnackbarWrapperSlice.reducer;

export const LoaderSnackbarWrapperActions = {
  ...LoaderSnackbarWrapperSlice.actions,
};
